import Gender from "./gender";
export default Gender;